import { render } from "./topOffices.vue?vue&type=template&id=68642df5&scoped=true"
import script from "./topOffices.vue?vue&type=script&lang=js"
export * from "./topOffices.vue?vue&type=script&lang=js"

import "./topOffices.vue?vue&type=style&index=0&id=68642df5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68642df5"]])

export default __exports__